// extracted by mini-css-extract-plugin
module.exports = {"md-up":"min-width: 769px","wrapper":"Home2_wrapper__33-xb","video":"Home2_video__3yaIb","thumbnail":"Home2_thumbnail__1JNxW Home2_video__3yaIb"};